export const TRX_METHOD = Object.freeze({
    CASH: 'Cash',
    CARD: 'Card',
    BANK_TRANSFER: 'Bank Transfer',
    CARD_BNPL: 'Card - BNPL',
    RAAST: 'Raast'
});

// Alfalah (APG) gateway status mapping to internal format
export const ALFALAH_STATUS_MAPPING = Object.freeze({
    'Paid': 'APPROVED',
    'Failed': 'DECLINED',
    'Initiated': 'PENDING'
});

// Abhipay gateway statuses (already in internal format, no mapping needed)
// APPROVED, DECLINED, PENDING, EXPIRED, CREATED, SETTLE_PENDING, SETTLED
export const ABHIPAY_STATUSES = Object.freeze([
    'APPROVED',
    'DECLINED', 
    'PENDING',
    'EXPIRED',
    'CREATED',
    'SETTLE_PENDING',
    'SETTLED'
]);

// Helper to normalize payment status from any gateway to internal format
export const normalizePaymentStatus = (status) => {
    if (!status) return null;
    
    // If it's already an Abhipay status, return as-is
    if (ABHIPAY_STATUSES.includes(status)) {
        return status;
    }
    
    // If it's an Alfalah status, map it
    if (ALFALAH_STATUS_MAPPING[status]) {
        return ALFALAH_STATUS_MAPPING[status];
    }
    
    // Unknown status, return as-is and log warning
    console.warn(`Unknown payment status: ${status}`);
    return status;
};

// Payment status constants for conditions
export const PAYMENT_STATUS = Object.freeze({
    APPROVED: 'APPROVED',
    DECLINED: 'DECLINED',
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
    CREATED: 'CREATED',
    SETTLE_PENDING: 'SETTLE_PENDING',
    SETTLED: 'SETTLED'
});
